import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControl, FormControlLabel, FormGroup } from '@material-ui/core';
import React, { useState, useEffect, FC } from 'react';
import { useDispatch } from 'react-redux';

import { IProfile } from '../../models/profile/teams';
import { useAppSelector } from '../../store';
import { getUserCelebratesDataById, setProfileData } from '../../store/features/profile/profileSlice';
import Celebration from './celebration';

const CelebrateDays: FC<IProfile> = ({ setIsCelebratingSpecialDay, isEdit, isTouched }) => {
    const initialState = {
        items: [],
    };

    const [allCelebrateDays, setAllCelebrateDays] = useState(initialState);
    const { words } = useAppSelector(state => state.localization);
    const { profileData } = useAppSelector(state => state.profile);
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const { items, isCelebratingSpecialDay } = useAppSelector(state => state.profile.userCelebrates);
    const dispatch = useDispatch();

    useEffect(() => {
        setIsChecked(isCelebratingSpecialDay)
    }, [isCelebratingSpecialDay])

    useEffect(() => {
        setAllCelebrateDays(prevState => {
            return {
                ...prevState,
                items: items
            };
        });
    }, [items])

    const updateUserCelebrate = async (data, index) => {
        const arrayObj = [...allCelebrateDays.items];
        arrayObj[index] = data;

        setAllCelebrateDays({
            ...allCelebrateDays,
            items: arrayObj,
        });
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const userId = queryParams.get('u');
        if (!userId) return;
        if (userId) {
            dispatch(getUserCelebratesDataById(userId));
        }
    }, []);

    const addNewCelebrate = () => {
        if (allCelebrateDays.items.length < 5) {
            const celebrateArray = [...allCelebrateDays.items];
            celebrateArray.push({
                id: null,
                specialDateId: null,
                specialDateName: '',
                celebrationForWhomId: null,
                celebrationForWhomName: '',
                name: '',
                specialDateCategoryId: null,
            });

            setAllCelebrateDays({
                ...allCelebrateDays,
                items: celebrateArray,
            });
        }
    };

    const deleteCelebrateByIndex = (index: number) => {
        const filtered = [];
        for (let i = 0; i < allCelebrateDays.items.length; i++) {
            if (i !== index) {
                filtered.push(allCelebrateDays.items[i]);
            }
        }
        setAllCelebrateDays({
            ...allCelebrateDays,
            items: filtered,
        });
    };

    useEffect(() => {
        const allUserCelebrates = [];
        for (let i = 0; i < allCelebrateDays?.items?.length; i++) {
            const allUserCelebrate = allCelebrateDays.items[i];
            allUserCelebrates.push({
                id: allUserCelebrate?.id ? allUserCelebrate?.id : null,
                specialDateCategoryId: allUserCelebrate?.specialDateCategoryId ? allUserCelebrate?.specialDateCategoryId : null,
                isOther: allUserCelebrate?.isOther ? allUserCelebrate?.isOther : false,
                celebrationForWhomId: allUserCelebrate?.celebrationForWhomId?.length > 0 ? allUserCelebrate?.celebrationForWhomId : null,
                specialDateId: allUserCelebrate?.specialDateId?.length > 0 ? allUserCelebrate?.specialDateId : null,
                name: allUserCelebrate?.isOtherPerson ? allUserCelebrate?.isOtherPerson : '',
            });
        }
        dispatch(
            setProfileData({
                ...profileData,
                celebrate: allUserCelebrates,
            }),
        );
    }, [allCelebrateDays]);

    useEffect(() => {
        setIsCelebratingSpecialDay(isChecked);
    }, [isChecked]);

    const celebrationCheckboxMessage: string = isEdit
        ? words && words['WEB.iDontCelebrateProfessionalDay']
        : words && words['WEB.doesntCelebrateProfessionalDay'];

    return (
        <div className="c-item">
            <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon="" aria-controls="panel7a-content" id="panel7a-header">
                    <div className="c-item-01">
                        <h6>{isEdit ? words && words['WEB.yourCelebrateSpecialDays'] : words && words['WEB.celebrationSpecialDays']}</h6>
                        <div className="c-item-01-B">
                            <svg className="c-unit-01" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M9.29183 3.29196C9.38473 3.19883 9.49508 3.12494 9.61657 3.07453C9.73806 3.02412 9.8683 2.99817 9.99983 2.99817C10.1314 2.99817 10.2616 3.02412 10.3831 3.07453C10.5046 3.12494 10.6149 3.19883 10.7078 3.29196L22.7078 15.292C22.801 15.3848 22.8748 15.4952 22.9253 15.6167C22.9757 15.7382 23.0016 15.8684 23.0016 16C23.0016 16.1315 22.9757 16.2617 22.9253 16.3832C22.8748 16.5047 22.801 16.6151 22.7078 16.708L10.7078 28.708C10.5201 28.8957 10.2654 29.0012 9.99983 29.0012C9.73428 29.0012 9.47961 28.8957 9.29183 28.708C9.10406 28.5202 8.99857 28.2655 8.99857 28C8.99857 27.7344 9.10406 27.4797 9.29183 27.292L20.5858 16L9.29183 4.70796C9.19871 4.61507 9.12482 4.50471 9.07441 4.38322C9.024 4.26173 8.99805 4.13149 8.99805 3.99996C8.99805 3.86842 9.024 3.73818 9.07441 3.61669C9.12482 3.4952 9.19871 3.38485 9.29183 3.29196Z"
                                    fill="#2e333e"
                                />
                            </svg>

                            <svg className="c-unit-02" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M3.29183 9.79196C3.38473 9.69883 3.49508 9.62494 3.61657 9.57453C3.73806 9.52412 3.8683 9.49817 3.99983 9.49817C4.13137 9.49817 4.26161 9.52412 4.3831 9.57453C4.50459 9.62494 4.61494 9.69883 4.70783 9.79196L15.9998 21.086L27.2918 9.79196C27.3848 9.69898 27.4952 9.62523 27.6167 9.57491C27.7381 9.52459 27.8683 9.49869 27.9998 9.49869C28.1313 9.49869 28.2615 9.52459 28.383 9.57491C28.5045 9.62523 28.6149 9.69898 28.7078 9.79196C28.8008 9.88493 28.8746 9.99531 28.9249 10.1168C28.9752 10.2383 29.0011 10.3685 29.0011 10.5C29.0011 10.6314 28.9752 10.7616 28.9249 10.8831C28.8746 11.0046 28.8008 11.115 28.7078 11.208L16.7078 23.208C16.6149 23.3011 16.5046 23.375 16.3831 23.4254C16.2616 23.4758 16.1314 23.5017 15.9998 23.5017C15.8683 23.5017 15.7381 23.4758 15.6166 23.4254C15.4951 23.375 15.3847 23.3011 15.2918 23.208L3.29183 11.208C3.19871 11.1151 3.12482 11.0047 3.07441 10.8832C3.024 10.7617 2.99805 10.6315 2.99805 10.5C2.99805 10.3684 3.024 10.2382 3.07441 10.1167C3.12482 9.9952 3.19871 9.88485 3.29183 9.79196Z"
                                    fill="#2e333e"
                                />
                            </svg>
                        </div>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <div className="c-item-07">
                        {allCelebrateDays.items.length === 0 && ((!isEdit && isChecked) || isEdit) && (
                            <FormControl component="fieldset" className="form-group-05">
                                <FormGroup aria-label="position" row>
                                    <FormControlLabel
                                        control={<Checkbox checked={isChecked} disabled={!isEdit} onChange={e => setIsChecked(e.target.checked)} />}
                                        label={celebrationCheckboxMessage}
                                        labelPlacement="end"
                                    />
                                </FormGroup>
                            </FormControl>
                        )}
                        {!isEdit && !isChecked && allCelebrateDays?.items?.length === 0 && (
                            <div className="anyData">
                                <p className="info">{words && words['WEB.noInformationShared']}</p>
                            </div>
                        )}
                        {allCelebrateDays.items.length > 0 &&
                            allCelebrateDays.items.map((item, index) => (
                                <div className="c-item-07-A" key={'celebrateList' + item.id + index + item.specialDateId + item.celebrationForWhomId}>
                                    <Celebration
                                        data={item}
                                        index={index}
                                        updateUserCelebrate={updateUserCelebrate}
                                        deleteCelebrateByIndex={deleteCelebrateByIndex}
                                        isEdit={isEdit}
                                        isTouched={isTouched}
                                    />
                                </div>
                            ))}
                        {!isChecked && isEdit && allCelebrateDays.items.length < 5 && (
                            <a className="button-06" onClick={addNewCelebrate}>
                                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M20.0938 0.0625H2.90625C1.6123 0.0625 0.5625 1.1123 0.5625 2.40625V19.5938C0.5625 20.8877 1.6123 21.9375 2.90625 21.9375H20.0938C21.3877 21.9375 22.4375 20.8877 22.4375 19.5938V2.40625C22.4375 1.1123 21.3877 0.0625 20.0938 0.0625ZM18.5312 12.3672C18.5312 12.6895 18.2676 12.9531 17.9453 12.9531H13.4531V17.4453C13.4531 17.7676 13.1895 18.0312 12.8672 18.0312H10.1328C9.81055 18.0312 9.54688 17.7676 9.54688 17.4453V12.9531H5.05469C4.73242 12.9531 4.46875 12.6895 4.46875 12.3672V9.63281C4.46875 9.31055 4.73242 9.04688 5.05469 9.04688H9.54688V4.55469C9.54688 4.23242 9.81055 3.96875 10.1328 3.96875H12.8672C13.1895 3.96875 13.4531 4.23242 13.4531 4.55469V9.04688H17.9453C18.2676 9.04688 18.5312 9.31055 18.5312 9.63281V12.3672Z"
                                        fill="#2e333e"
                                    />
                                </svg>
                                <span className="text-01">{words && words['WEB.addNew']}</span>
                            </a>
                        )}
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};
export default CelebrateDays;
